import { useMap } from 'react-leaflet';
import IndexLegend from './IndexLegend';

const MapLegendWrapper = ({ legends }) => {
    const map = useMap();
    if (!legends?.legends) return null;  // Add null check for legends object
    return <IndexLegend
        map={map}
        legends={legends.legends.map(legend => ({
            color: legend.color,
            label: legend.value,
            label_ar:legend.value_ar
        }))}
        unit={legends.unit}
        unit_ar={legends.unit_ar}
    />;
};

export default MapLegendWrapper;